import Controller from './Controller';
import { trace } from 'rytm-helpers';
import { Tooltip } from 'bootstrap';

class CommentQuoteController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    this.initTooltips();
  }
  addEventListeners() {
    super.addEventListeners();
    document.documentElement.addEventListener("click", this.onDocClick);
  }
  removeEventListeners() {
    super.removeEventListeners();
    document.documentElement.removeEventListener("click", this.onDocClick);
  }
  /**
   * Own..
   */
  onDocClick = (e) => {
    if (e.target && e.target.classList.contains("copy-quote-btn")) {
      this.onCopyQuote(e);
    }
  }
  onCopyQuote(e) {
    e.preventDefault();
    const text = e?.target?.dataset?.copyText;
    if (text) {
      // copy to clipboard
      console.log(navigator, navigator.clipboard);
      navigator.clipboard.writeText(text).then(() => {
        // set tooltip text
        const textInit = e?.target?.dataset?.bsTitle;
        const textSuccess = e?.target?.dataset?.copySuccess;
        if (textInit && textSuccess) {
          const tooltip = Tooltip.getInstance(e.target);
          if (tooltip) {
            tooltip.setContent({'.tooltip-inner': textSuccess});
            clearTimeout(this.copySuccessTimeout);
            this.copySuccessTimeout = setTimeout(() => {
              tooltip.hide();
              tooltip.setContent({'.tooltip-inner': textInit});
            }, 2000);
          }
        }
      }, (err) => {
        window.prompt(text);
      });
    }
  }
  initTooltips() {
    const container = document.querySelector(this.getContainerSelector());
    const tooltipTriggerList = container.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
  }  


}

export default CommentQuoteController;